export default __webpack_public_path__ + "static/media/doubleAdjustmentHorizontal.5ac3e673.svg";